"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
const alert_serializer_1 = require("../serializers/alert.serializer");
class AlertClient {
    constructor(client, serializer) {
        this.client = client;
        this.serializer = serializer;
    }
    static newInstance(options, retryOptions) {
        return new AlertClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new alert_serializer_1.AlertSerializer());
    }
    async findByOwner(filters, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/alerts.findByOwner`, {
            headers,
            params: {
                ...filters,
            },
        });
        return this.serializer.serialize(response.body);
    }
    async read(alertId, headers) {
        const response = await this.client.put(`${sdk_constants_1.API_PREFIX}/alerts.read/${alertId}`, {}, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
}
exports.AlertClient = AlertClient;
//# sourceMappingURL=alert.client.js.map